var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTildiCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1111_13322)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3189 4.43101L8.49988 18.249C8.40697 18.3423 8.29655 18.4163 8.17497 18.4668C8.05339 18.5173 7.92303 18.5433 7.79138 18.5433C7.65972 18.5433 7.52937 18.5173 7.40778 18.4668C7.2862 18.4163 7.17579 18.3423 7.08288 18.249L1.73888 12.9C1.64597 12.8067 1.53555 12.7327 1.41397 12.6822C1.29239 12.6317 1.16203 12.6057 1.03038 12.6057C0.898723 12.6057 0.768365 12.6317 0.646783 12.6822C0.5252 12.7327 0.414787 12.8067 0.321877 12.9V12.9C0.2286 12.9929 0.154588 13.1033 0.104086 13.2249C0.0535845 13.3465 0.0275879 13.4769 0.0275879 13.6085C0.0275879 13.7402 0.0535845 13.8705 0.104086 13.9921C0.154588 14.1137 0.2286 14.2241 0.321877 14.317L5.66788 19.662C6.23183 20.2249 6.99607 20.5411 7.79288 20.5411C8.58968 20.5411 9.35393 20.2249 9.91788 19.662L23.7359 5.84701C23.829 5.75412 23.9029 5.64377 23.9533 5.52228C24.0037 5.40079 24.0297 5.27054 24.0297 5.13901C24.0297 5.00747 24.0037 4.87723 23.9533 4.75574C23.9029 4.63425 23.829 4.5239 23.7359 4.43101C23.643 4.33773 23.5326 4.26372 23.411 4.21322C23.2894 4.16272 23.159 4.13672 23.0274 4.13672C22.8957 4.13672 22.7654 4.16272 22.6438 4.21322C22.5222 4.26372 22.4118 4.33773 22.3189 4.43101Z",
    fill: "#405C43"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1111_13322"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTildiCheckIcon);
export default __webpack_public_path__ + "static/media/tildi-check-icon.1bfbed2654538482b9ea65b9909abb33.svg";
export { ForwardRef as ReactComponent };